import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  SendBroadCast,
  GetService,
  getBroadCastmessage,
  ChangeBroadCastStatus,
  DeleteBroadCastmessage,
  UpdateCastmessage,
} from "../../../Services/Admin/Admin";
import Table from "../../../Extracomponents/Table";
import { SquarePen, Trash2, PanelBottomOpen, Eye } from "lucide-react";
import { Tooltip, Pagination } from "antd";
import { fDateTime } from "../../../../Utils/Date_formate";
import Loader from "../../../../Utils/Loader";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";

const Message = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [servicedata, setServicedata] = useState({});
  const [chatMessages, setChatMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getservice();
  }, []);

  useEffect(() => {
    sendmessagedetail();
  }, [currentPage]);

  const getservice = async () => {
    try {
      const response = await GetService(token);
      if (response.status) {
        setServicedata(response?.data);
      }
    } catch (error) {
      console.log("Error fetching services:", error);
    }
  };

  const sendmessagedetail = async () => {
    setIsLoading(true);
    try {
      const data = { page: currentPage, limit: 10 };
      const response = await getBroadCastmessage(data, token);
      if (response.status) {
        setChatMessages(response.data);
        setTotalRows(response.pagination?.total || 0);
      }
    } catch (error) {
      console.log("Error fetching broadcast messages:", error);
    }
    setIsLoading(false);
  };

  const DeleteMessage = async (_id) => {
    try {
      const result = await showCustomAlert(
        "confirm",
        "Do you want to delete this broadcast message? This action cannot be undone."
      );

      if (result.isConfirmed) {
        const response = await DeleteBroadCastmessage(_id, token);
        if (response.status) {
          showCustomAlert(
            "Success",
            "The message has been successfully deleted."
          );
          sendmessagedetail();
        }
      }
    } catch (error) {
      showCustomAlert("error", "There was an error deleting the message.");
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div>
      <div className="page-content">
        <div className="page-breadcrumb d-flex align-items-center mb-3">
          <div className="breadcrumb-title pe-3">Message Broadcast</div>
          <div className="ps-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0 p-0">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard">
                    <i className="bx bx-home-alt" />
                  </Link>
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <hr />

        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center">
                <Link to="/admin/addbroadcast" className="btn btn-primary me-3">
                  <i className="bx bxs-plus-square" /> Add Broadcast
                </Link>
              </div>
            </div>

            {isLoading ? (
              <Loader />
            ) : (
              <div className="page-content">
                <div className="container py-2">
                  {chatMessages?.length > 0 ? (
                    <>
                      {chatMessages.map((item, index) => {
                        const serviceIds = item.service?.split(",");
                        const matchedServices = serviceIds
                          ?.map((serviceId) =>
                            (Array.isArray(servicedata) ? servicedata : []).find(
                              (service) => service?._id === serviceId
                            )
                          )
                          .filter(Boolean);

                        return (
                          <div className="row" key={index}>
                            <div className="col py-2">
                              <div
                                className="card"
                                style={{ borderRadius: "10px" }}
                              >
                                <div className="card-body">
                                  <div className="float-end text-muted">
                                    <button
                                      className="btn btn-primary btn-sm me-2"
                                      onClick={() =>
                                        navigate("/admin/broadcastrequest", {
                                          state: { broadcast_id: item._id },
                                        })
                                      }
                                    >
                                      Broadcast Request
                                    </button>

                                    <Tooltip
                                      placement="top"
                                      overlay={
                                        item.schedulestatus === "sent"
                                          ? "Already sent - cannot update"
                                          : "Update"
                                      }
                                    >
                                      <SquarePen
                                        className="me-2"
                                        style={{
                                          cursor:
                                            item.schedulestatus === "sent"
                                              ? "not-allowed"
                                              : "pointer",
                                          opacity:
                                            item.schedulestatus === "sent"
                                              ? 0.4
                                              : 1,
                                        }}
                                        onClick={() => {
                                          if (item.schedulestatus === "sent")
                                            return;
                                          navigate("/admin/updatebroadcast", {
                                            state: { item },
                                          });
                                        }}
                                      />
                                    </Tooltip>

                                    <Tooltip placement="top" overlay="Delete">
                                      <Trash2
                                        style={{ cursor: "pointer" }}
                                        onClick={() => DeleteMessage(item._id)}
                                      />
                                    </Tooltip>
                                  </div>
                                  <h4 className="card-title text-white">
                                    <span>
                                      {matchedServices?.length > 0 ? (
                                        matchedServices.some((service) =>
                                          ["C", "O", "F", "OS"].includes(
                                            service.segment
                                          )
                                        ) ? (
                                          matchedServices.map(
                                            (service, idx) => (
                                              <span key={idx}>
                                                {service.segment === "C" && (
                                                  <span>CASH </span>
                                                )}
                                                {service.segment === "O" && (
                                                  <span>OPTION </span>
                                                )}
                                                {service.segment === "F" && (
                                                  <span>FUTURE </span>
                                                )}
                                                {service.segment === "OS" && (
                                                  <span>Strategy</span>
                                                )}
                                              </span>
                                            )
                                          )
                                        ) : (
                                          <span>All </span>
                                        )
                                      ) : (
                                        <span>All </span>
                                      )}
                                    </span>
                                    ({item.type})
                                  </h4>

                                  <hr />
                                  <p className="text-white">
                                    <strong>Subject:</strong> {item.subject}
                                  </p>
                                  <div className="text-white">
                                    <strong>Message:</strong>
                                    <div
                                      className="mt-2"
                                      dangerouslySetInnerHTML={{
                                        __html: item.message.replace(
                                          /<img /g,
                                          '<img style="width: 300px; height: 150px; object-fit: cover;" '
                                        ),
                                      }}
                                    />
                                  </div>
                                  <p className="text-white mt-3">
                                    <strong>Redirect Type:</strong>{" "}
                                    {item.redirecttype || "N/A"}
                                  </p>
                                  <p className="text-white">
                                    <strong>Schedule At:</strong>{" "}
                                    {item?.scheduleAt
                                      ? new Date(
                                          item.scheduleAt
                                        ).toLocaleString("en-IN", {
                                          day: "2-digit",
                                          month: "short",
                                          year: "numeric",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: true,
                                        })
                                      : "N/A"}
                                  </p>

                                  <p className="text-white">
                                    <strong>Created At:</strong>{" "}
                                    {fDateTime(item.created_at)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      <div className="d-flex justify-content-end mt-4">
                        <Pagination
                          current={currentPage}
                          total={totalRows}
                          pageSize={10}
                          onChange={handlePageChange}
                          showSizeChanger={false}
                        />
                      </div>
                    </>
                  ) : (
                    <div className="text-center mt-5">
                      <img
                        src="/assets/images/nodata.png"
                        alt="No Records Found"
                        className="w-25"
                      />
                      <p className="mt-3">No broadcast messages found.</p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Message;
